import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackNudgeProtocolsToggledSpec,
  type NudgeProtocolsToggled,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const nudgeEvents: SnowplowEventMap = {
  [TrackingEventName.NudgeProtocolsToggled]: (props) =>
    trackNudgeProtocolsToggledSpec(props as NudgeProtocolsToggled),
};
